import { FC, PropsWithChildren, useLayoutEffect, useRef, useState } from 'react';

import { Text } from '@hh.ru/magritte-ui';

import DynamicCollapseTrigger from 'src/components/ResumeCard/Body/Collapse/Trigger/Dynamic';
import { useToggleState } from 'src/hooks/useToggleState';

const CollapseText: FC<PropsWithChildren & { dataQa?: string }> = ({ dataQa, children }) => {
    const startRef = useRef<HTMLSpanElement>(null);
    const endRef = useRef<HTMLSpanElement>(null);

    const [expanded, toggleExpanded, setExpanded] = useToggleState(true);
    const [showTrigger, setShowTrigger] = useState(false);

    useLayoutEffect(() => {
        if (!startRef.current || !endRef.current) {
            return;
        }
        const show = endRef.current.offsetTop > startRef.current.offsetTop;
        setShowTrigger(show);
        setExpanded(!show);
    }, [setExpanded, setShowTrigger, children]);

    return (
        <>
            <Text typography="label-3-regular" maxLines={expanded ? undefined : 1}>
                <span ref={startRef} />
                {children}
                <span ref={endRef} />
            </Text>
            {showTrigger && (
                <DynamicCollapseTrigger
                    expanded={expanded}
                    onToggle={toggleExpanded}
                    dataQa={`${dataQa || 'content'}-collapse-trigger`}
                />
            )}
        </>
    );
};

export default CollapseText;
